export function calcCustoPedido(p, impressoras = [], produtos = []) {
  const cFil = (p.filamentos_usados||[]).reduce((s,f)=>s+(parseFloat(f.custo_total)||0),0);
  const imp  = impressoras.find(i=>i.id===p.impressora_id);
  const hrs  = parseFloat(p.horas_impressao)||0;
  const cEn  = imp&&hrs ? (parseFloat(imp.consumo_hr)||0)*hrs : 0;
  const cDes = imp&&hrs ? (parseFloat(imp.desgaste_hr)||0)*hrs : 0;
  const cMat = (p.materiais_usados||[]).reduce((s,m)=>s+(parseFloat(m.custo_unitario)||0)*(parseFloat(m.qtd)||0),0);
  const cMO  = (parseFloat(p.mao_obra_hrs)||0)*(parseFloat(p.mao_obra_valor_hr)||0);
  const cItens = (p.itens||[]).reduce((s,it)=>{
    const qtd = parseInt(it.qtd)||1;
    if (it.custo_unit != null) return s + (parseFloat(it.custo_unit)||0)*qtd;
    const prod = produtos.find(pr=>pr.id===it.produto_id);
    if (prod) return s + custoUnitarioProduto(prod, impressoras)*qtd;
    const itFil = (it.filamentos_usados||[]).reduce((a,f)=>a+(parseFloat(f.custo_total)||0),0);
    return s + itFil*qtd;
  }, 0);
  // Venda online: taxas da loja/cartão + frete que o vendedor pagou (ver utils/vendaOnline.js)
  const cVenda = parseFloat(p.venda_online?.custo_venda)||0;
  const total = cFil+cEn+cDes+cMat+cMO+cItens+cVenda;
  return { cFil, cEn, cDes, cMat, cMO, cItens, cVenda, total };
}

// Custo de UMA peça do catálogo. `custo_total` já é por peça (calculadora e
// editor de produto dividem pelo lote). A conta manual fica só para produto
// sem ele: filamento é por peça, mas tempo, materiais e mão de obra são do lote.
export function custoUnitarioProduto(prod, impressoras = []) {
  const cadastrado = parseFloat(prod.custo_total);
  if (cadastrado > 0) return cadastrado;
  const lote = Math.max(1, parseInt(prod.unidades) || 1);
  const pi = impressoras.find(i=>i.id===prod.impressora_id);
  const ph = parseFloat(prod.horas_impressao)||0;
  const pFil = (prod.filamentos_usados||[]).reduce((a,f)=>a+(parseFloat(f.custo_total)||0),0);
  const pEn  = pi&&ph ? (parseFloat(pi.consumo_hr)||0)*ph : 0;
  const pDes = pi&&ph ? (parseFloat(pi.desgaste_hr)||0)*ph : 0;
  const pMat = (prod.materiais_usados||[]).reduce((a,m)=>a+(parseFloat(m.custo_unitario)||0)*(parseFloat(m.qtd)||0),0);
  const pMO  = (parseFloat(prod.mao_obra_hrs)||0)*(parseFloat(prod.mao_obra_valor_hr)||0);
  return pFil + (pEn+pDes+pMat+pMO)/lote;
}
